import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

export const ReportCategoryFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    return (
      <GenericFilterDropdown
        filterParam={FilterParam.REPORT_CATEGORIES}
        filterName={FilterName.REPORT_CATEGORIES}
        valueKey="reportCategories"
        isNested={isNested}
      />
    )
  },
)
